import { readFileSync } from 'fs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class InspectionsService {

    constructor(private http: HttpClient) { }

    getPendings(page, search) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        const body = {
            page: page,
            search: search
        }

        return this.http.post<any>(`${environment.apiUrl}/inspections/pending`, body, { headers });
    }

    getAssigned(page, search) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        const body = {
            page: page,
            search: search
        }

        return this.http.post<any>(`${environment.apiUrl}/inspections/programmed`, body, { headers });
    }

    getChecklist(page, search) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        const body = {
            page: page,
            search: search
        }

        return this.http.post<any>(`${environment.apiUrl}/inspections/checklist`, body, { headers });
    }

    getNotAnnounced(page, search) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        const body = {
            page: page,
            search: search
        }

        return this.http.post<any>(`${environment.apiUrl}/inspections/getNotAnnounced`, body, { headers });
    }

    getCurrent(inspectionId) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        return this.http.get<any>(`${environment.apiUrl}/inspections/${inspectionId}`, { headers });
    }

    getInspectors(inspectionId: Number) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        return this.http.get<any>(`${environment.apiUrl}/inspections/inspectors/${inspectionId}`, { headers });
    }

    changeInspector(payload, inspectionId) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        }

        return this.http.patch<any>(`${environment.apiUrl}/inspections/inspectors/assign/${inspectionId}`, payload, { headers });
    }

    getInspectionToChecklist(inspectionId) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        return this.http.get<any>(`${environment.apiUrl}/inspections/${inspectionId}/checklist`, { headers });
    }

    sendDecisionChecklist(inspectionId: number, inspectorId: number, decision: 0 | 1, data: Partial<{ order: string; informe: string, anexos: string; others: string }>) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        const payload = {
            order: data.order,
            informe: data.informe,
            anexos: data.anexos,
            others: data.others
        }

        return this.http.patch<any>(`${environment.apiUrl}/inspections/${inspectionId}/${inspectorId}/checklist/${decision}`, payload, { headers });
    }

    assign(inspectionId) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        const payload = {}

        return this.http.patch<any>(`${environment.apiUrl}/inspections/${inspectionId}/assign`, payload, { headers });
    }

    acceptInspection(inspectionId) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-type': 'application/json',
            'Authorization': jwtToken
        };

        const payload = {}
        
        return this.http.post<any>(`${environment.apiUrl}/inspections/${inspectionId}/accept`, payload, { headers });
    }

    denyInspection(inspectionId, comment) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-type': 'application/json',
            'Authorization': jwtToken
        };

        const payload = {
            comments: comment
        }
        
        return this.http.post<any>(`${environment.apiUrl}/inspections/${inspectionId}/deny`, payload, { headers });
    }

    uploadPreview(file: Blob, ext: string) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'authorization': jwtToken
        };

        const payload = new FormData()
        payload.append('file', file, 'file.' + ext)

        return this.http.post<any>(`${environment.apiUrl}/inspections/preview`, payload, { headers });
    }

    getInspectionData(inspectionId) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        return this.http.get<any>(`${environment.apiUrl}/inspections/inspection/${inspectionId}`, { headers });
    }

    signInspection(inspectionId: number, inspectorId: number) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        return this.http.patch<any>(`${environment.apiUrl}/inspections/${inspectionId}/${inspectorId}/sign`, {}, { headers });
    }

    inspectionComplete(inspectionId, values) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        const payload = values

        return this.http.patch<any>(`${environment.apiUrl}/inspections/inspection/${inspectionId}/complete`, payload, { headers });
    }

    getOrderForms(version) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        return this.http.get<any>(`${environment.apiUrl}/inspections/order/forms/${version}`, { headers });
    }

    getPlanForms(inspectionId: number, inspectorId: number) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        return this.http.get<any>(`${environment.apiUrl}/inspections/${inspectionId}/${inspectorId}/plan`, { headers });
    }

    getPlanOnly(inspectionId: number, inspectorId: number) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        return this.http.get<any>(`${environment.apiUrl}/inspections/${inspectionId}/${inspectorId}/inspectionplan`, { headers });
    }

    getPlanOnlySubmission(inspectionId, inspectorId, formId) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        return this.http.get<any>(`${environment.apiUrl}/inspections/${inspectionId}/${inspectorId}/inspectionplan/submission/${formId}`, { headers });
    }

    getPlanForm(inspectionId: number, inspectorId: number, formId: number) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        return this.http.get<any>(`${environment.apiUrl}/inspections/${inspectionId}/${inspectorId}/plan/${formId}`, { headers });
    }

    getForm(inspectionId: number, inspectorId: number, formId: number) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        return this.http.get<any>(`${environment.apiUrl}/inspections/${inspectionId}/${inspectorId}/form/${formId}`, { headers });
    }

    saveFormOrder(inspectionId, formId, form, dates, inspectors, responsible?, responsibleId?, notChange = false) {
        let body = {
            submission: []
        }

        if (!notChange) {
            for (var i in Object.keys(form)) {
                const key = Object.keys(form)[i]
                body.submission.push({
                    name: key,
                    value: form[key]
                })
            }
        } else {
            body.submission = form
        }

        if (dates) {
            for (var i in Object.keys(dates)) {
                const key = Object.keys(dates)[i]
                body.submission.push({
                    name: key,
                    value: dates[key]
                })
            }
        }

        if (inspectors) {
            let have_inspectors = false
            for(let i in body.submission) {
                if(body.submission[i].name === 'inspector') have_inspectors = true
            }

            if(have_inspectors) {
                for(let i in body.submission) {
                    if(body.submission[i].name === 'inspector') 
                        body.submission[i].value = Object.values(inspectors as Record<string, { id: number; name: string }>).map((inspector) => {
                                return {
                                    id: inspector.id,
                                    name: inspector.name
                                }
                            })
                }
            } else {
                const inspectorsArray = Object.values(inspectors as Record<string, { id: number; name: string }>).map((inspector) => {
                    return {
                        id: inspector.id,
                        name: inspector.name
                    }
                })

                body.submission.push({
                    name: 'inspector',
                    value: inspectorsArray
                })
            }
        }

        if (responsible) {
            body.submission.push({
                name: 'responsible',
                value: responsible
            })

            body.submission.push({
                name: 'responsibleId',
                value: responsibleId
            })
        }

        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        return this.http.post<any>(`${environment.apiUrl}/inspections/${inspectionId}/form/${formId}/submit`, body, { headers });
    }

    saveForm(inspectionId, formId, form, inspectorId, dates, inspectors, responsible?, responsibleId?, notChange = false) {
        let body = {
            submission: []
        }

        if (!notChange) {
            for (var i in Object.keys(form)) {
                const key = Object.keys(form)[i]
                body.submission.push({
                    name: key,
                    value: form[key]
                })
            }
        } else {
            body.submission = form
        }

        if (dates) {
            for (var i in Object.keys(dates)) {
                const key = Object.keys(dates)[i]
                body.submission.push({
                    name: key,
                    value: dates[key]
                })
            }
        }

        if (inspectors) {
            let have_inspectors = false
            for(let i in body.submission) {
                if(body.submission[i].name === 'inspector') have_inspectors = true
            }

            if(have_inspectors) {
                for(let i in body.submission) {
                    if(body.submission[i].name === 'inspector') 
                        body.submission[i].value = {
                            id: inspectorId,
                            name: inspectors
                        }
                }
            } else {
                body.submission.push({
                    name: 'inspector',
                    value: {
                        id: inspectorId,
                        name: inspectors
                    }
                })
            }
        }

        if (responsible) {
            body.submission.push({
                name: 'responsible',
                value: responsible
            })

            body.submission.push({
                name: 'responsibleId',
                value: responsibleId
            })
        }

        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        return this.http.post<any>(`${environment.apiUrl}/inspections/${inspectionId}/${inspectorId}/form/${formId}/submit`, body, { headers });
    }

    saveTypeInspection(inspectionId, type) {
        let body = {
            type: type
        }

        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        return this.http.post<any>(`${environment.apiUrl}/inspections/${inspectionId}/assingtype`, body, { headers });
    }

    saveFormOffline(inspectionId, formId, form, dates, inspector) {
        let body = {
            submission: form
        }

        if (inspector) {
            body.submission.push({
                name: 'inspector',
                value: inspector
            })
        }
        //console.log(body)

        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        return this.http.post<any>(`${environment.apiUrl}/inspections/${inspectionId}/form/${formId}/submit`, body, { headers });
    }

    uploadInspectionPlan(inspectionId: number, inspectorId: number, file: Blob) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Authorization': jwtToken
        };

        const body = new FormData()
        body.append('file', file, 'file.docx')

        return this.http.post<any>(`${environment.apiUrl}/inspections/${inspectionId}/${inspectorId}/upload`, body, { headers });
    }

    getInspectionPlanFile(inspectionId) {
        return this.http.get<any>(`${environment.apiUrl}/inspections/${inspectionId}/file`);
    }

    getUrlStatus(url: string) {
        return this.http.get(url);
    }

    getLastNoConformidades(inspectionId) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        return this.http.get<any>(`${environment.apiUrl}/inspections/${inspectionId}/getLatestNoConformities`, { headers });
    }

    getResultReview(recordId) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        };

        return this.http.get<any>(`${environment.apiUrl}/inspections/${recordId}/reviewResults`, { headers });
    }
}